var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('v-row',{staticStyle:{"height":"100%"}},[_c('v-col',{attrs:{"cols":"12","md":"4"}},[(_vm.schedule)?_c('info',{attrs:{"schedule":_vm.schedule}}):_vm._e()],1),_c('v-col',[(_vm.schedule)?_c('gatewaysTable',{attrs:{"schedule":_vm.schedule}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }